<template>
  <div
    v-if="tooltipText"
    ref="trigger"
    class="has-tooltip relative inline-block"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
  >
    <span
      ref="tooltip"
      class="tw-tooltip"
      :style="tooltipStyle"
    >
      {{ tooltipText }}
    </span>

    <slot />
  </div>

  <slot v-else />
</template>

<script>
export default {
  props: {
    tooltipText: { type: String, default: undefined },
    placement: {type: String, default: 'right'},
    width: {type: Number, default: 300}
  },
  data() {
    return {
      tooltipTimer: null,
      tooltipStyle: {
        position: 'fixed',
        left: '0px',
        top: '0px',
        opacity: 0,
        zIndex: 9999,
      },
    }
  },

  methods: {
    showTooltip() {
      this.tooltipTimer = window.setTimeout(() => {
      window.removeEventListener('scroll', this.hideTooltip, true)
      window.addEventListener('scroll', this.hideTooltip, true)

      this.$nextTick(() => {
        const trigger = this.$refs.trigger
        const tooltip = this.$refs.tooltip

        if (!trigger || !tooltip) return

        const rect = trigger.getBoundingClientRect()
        const tooltipWidth = this.width
        const tooltipHeight = tooltip.offsetHeight
        const gap = 8

        let left
        let top

        switch (this.placement) {
          case 'left':
            left = rect.left - tooltipWidth - gap
            top = rect.top + (rect.height - tooltipHeight) / 2
            break

          case 'right':
            left = rect.right + gap
            top = rect.top + (rect.height - tooltipHeight) / 2
            break

          case 'top':
          default:
            left = rect.left
            top = rect.top - tooltipHeight - gap
            break
        }

        // Keep the tooltip inside the viewport
        left = Math.max(
          8,
          Math.min(left, window.innerWidth - tooltipWidth - 8)
        )

        top = Math.max(
          8,
          Math.min(top, window.innerHeight - tooltipHeight - 8)
        )

        this.tooltipStyle = {
          position: 'fixed',
          left: `${left}px`,
          top: `${top}px`,
          width: `${tooltipWidth}px`,
          opacity: 1,
          zIndex: 9999,
        }
      })
      }, 1000)
    },

    hideTooltip() {
      window.clearTimeout(this.tooltipTimer)
      this.tooltipTimer = null

      this.tooltipStyle = {
        ...this.tooltipStyle,
        opacity: 0,
      }

      window.removeEventListener('scroll', this.hideTooltip, true)
    },
  },
  beforeUnmount() {
    window.clearTimeout(this.tooltipTimer)
    window.removeEventListener('scroll', this.hideTooltip, true)
  }
}
</script>
